import { notFound } from "next/navigation";

import { type AppLocale, isAppLocale, LOCALE_LABELS, SUPPORTED_LOCALES } from "@/core/i18n/config";

export function getLocalizedPath(locale: AppLocale, pathname = "/"): string {
  const normalizedPath = pathname.startsWith("/") ? pathname : `/${pathname}`;

  if (normalizedPath === "/") {
    return `/${locale}`;
  }

  return `/${locale}${normalizedPath}`;
}

export function localizeHref(locale: AppLocale, href: string): string {
  if (!href.startsWith("/")) {
    return href;
  }

  const segments = href.split("/");
  const firstSegment = segments[1] ?? "";

  if (isAppLocale(firstSegment)) {
    const localizedRemainder = segments.slice(2).join("/");
    return localizedRemainder ? `/${locale}/${localizedRemainder}` : `/${locale}`;
  }

  return getLocalizedPath(locale, href);
}

export function getLocaleFromRouteParam(locale: string): AppLocale {
  if (isAppLocale(locale)) {
    return locale;
  }

  notFound();
}

export function getLocaleSwitcherOptions(currentPath = "/") {
  return SUPPORTED_LOCALES.map((locale) => ({
    href: getLocalizedPath(locale, currentPath),
    label: LOCALE_LABELS[locale],
    locale,
  }));
}
